// extracted by mini-css-extract-plugin
export default {"cls1":"qcIpvV_VJBrCjm3NAvB6","cls2":"_KHDBDIuuG0nC04ajkDf qcIpvV_VJBrCjm3NAvB6"};